import { createClient, User } from "@supabase/supabase-js";

const SUPABASE_URL = 'https://iwjadriqbhyssyidwiqb.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml3amFkcmlxYmh5c3N5aWR3aXFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyNDQ0MzIsImV4cCI6MjA1MjgyMDQzMn0.uw9412cjTpJtD-KWcLW0kdgEhyeDPbzKrE1GxYQw1E0';
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

class Api {
    async signIn(email: string, password: string): Promise<User> {
        const { data: { user }, error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });
        if (error) throw error;
        if (!user) throw new Error('Failed to sign in');
        return user;
    }

    async signOut() {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
    }

    async getCurrentUser(): Promise<User | null> {
        const { data: { user } } = await supabase.auth.getUser();
        return user;
    }

    async fetchMeasurements(sinceCreatedAt: string): Promise<DataPoint[]> {
        const { data, error } = await supabase
            .rpc('measurements_min15', {
                since_created_at: sinceCreatedAt
            })

        if (error) {
            throw new Error('Failed to fetch data');
        }

        return data.map((point: any) => ({
            ...point,
            created_at: new Date(point.created_at)
        })) as DataPoint[];
    }
}

export default Api;
